/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentRoamId = (state) => get(state, ['currentRoam', 'items']);

export const getCurrentRoam = (state) => {

    return get(state, ['currentRoam', 'items'], []);
};

export const requestingCurrentRoam = (state) => get(state, ['currentRoam', 'requesting'], false);

export const errorRequestingCurrentRoam = (state) => get(state, ['currentRoam', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentRoam,
    (currentRoam) => {
        return get(currentRoam, ['has_scheduled_changes'], false);
    },
);
export const getCurrentRoamPlanId = createSelector(
    getCurrentRoam,
    (currentRoam) => {
        return get(currentRoam, ['plan_id'], null);
    },
);